const baseInit = {
  headers: {
    "Accept-Language": "en",
  },
  response: true,
};

export default baseInit;
